import React from 'react';
import '../styles/components.css';

const Header = () => {
  return (
    <header className="header">
      <h1>DOCT Volume Tracker</h1>
    </header>
  );
};

export default Header;

